import {
  STEP_ROUTE_PATH,
  STEP_URL_SECTION,
  STORE_BONUS_ID_URL_SECTION,
} from './consts';

export const createFormStepURL = (id, step) =>
  STEP_ROUTE_PATH.replace(STORE_BONUS_ID_URL_SECTION, id).replace(
    STEP_URL_SECTION,
    step,
  );

export const generateRandomId = () =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15);
